import { Modal, Button } from 'react-bootstrap';
import type { Review } from '../types';

interface DeleteReviewModalProps {
  show: boolean;
  review: Review | null;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
}

export const DeleteReviewModal = ({ show, review, onClose, onConfirm, isDeleting = false }: DeleteReviewModalProps) => {
  if (!review) {
    return null;
  }

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Delete</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>Are you sure you want to delete this review?</p>
        <div className="bg-light p-3 rounded">
          <strong>Review ID:</strong> {review.reviewId}
          <br />
          <strong>Product ID:</strong> {review.productId}
          <br />
          <strong>Reviewer:</strong> {review.name}
          <br />
          <strong>Title:</strong> {review.title}
        </div>
        <p className="text-danger mt-3 mb-0">
          <small>This action cannot be undone.</small>
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isDeleting}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? 'Deleting...' : 'Delete Review'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
